<template>

    <div v-if="enquiry!=null">
        <nav class="navbar navbar-expand navbar-primary navbar-dark">
            <!-- Left navbar links -->
            <ul class="navbar-nav">
                <li class="nav-item">
                    <a class="nav-link"  href="#" role="button">TRIP ID - {{enquiry.id}}</a>

                </li>


            </ul>

            <!-- Right navbar links -->
            <ul class="navbar-nav ml-auto">





                <li class="nav-item bg-white" v-if="enquiry.is_hot==1">
                    <a class="nav-link text-danger"  href="#" role="button"><img style="height: 20px;" src="/images/hot.png"/> &nbsp;Hot Lead</a>

                </li>

                <li class="nav-item ml-2" v-bind:class="{ 'bg-warning': enquiry.status=='Pending' ,'bg-red':enquiry.status=='Closed','bg-success':enquiry.status=='Convered','bg-info':enquiry.status=='InProgress'}">
                    <a class="nav-link"  href="#" role="button">{{enquiry.status}}</a>

                </li>
                <li class="nav-item ml-2" >

                    <a class="nav-link btn-outline-primary"  :href="'/viewenquiry?id='+enquiry.encryptedid" role="button">BACK</a>
                </li>


            </ul>
        </nav>
        <section class="content pt-3">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-3">
                        <div class="col-12 col-sm-12 col-md-12 d-flex align-items-stretch flex-column">
                            <div class="card bg-light d-flex flex-fill">
                                <div class="card-header text-muted border-bottom-0">
                                    TRAVELER DETAIL
                                </div>
                                <div class="card-body pt-0">
                                    <div class="row">
                                        <div class="col-12">
                                            <h2 class="lead"><b>{{enquiry.name}}</b></h2>
                                            <ul class="ml-4 mb-0 fa-ul text-muted">

                                                <li class="small"><span class="fa-li"><i class="fas fa-lg fa-phone"></i></span> Phone : {{enquiry.mobile}}</li>
                                                <li class="small"><span class="fa-li"><i class="fas fa-lg fa-envelope"></i></span> Email : {{enquiry.email_id}}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 d-flex align-items-stretch flex-column">
                            <div class="card bg-light d-flex flex-fill">
                                <div class="card-header text-muted border-bottom-0">
                                    TRAVELER REQUIREMENT
                                </div>
                                <div class="card-body pt-0">
                                    <div class="row">
                                        <div class="col-md-12 col-sm-12">

                                            <ul class="ml-4 mb-0 fa-ul ">
                                                <li class="small text-muted"> Duration</li>
                                                <li class="small" v-if="enquiry.nights>0"> {{enquiry.nights}} Nights {{enquiry.nights+1}} Days</li>
                                            </ul>
                                        </div>
                                        <div class="col-md-12 col-sm-12">

                                            <ul class="ml-4 mb-0 fa-ul ">
                                                <li class="small text-muted">Starting Date</li>
                                                <li class="small"> {{enquiry.departure_date}}</li>
                                            </ul>
                                        </div>
                                        <div class="col-md-12 col-sm-12">

                                            <ul class="ml-4 mb-0 fa-ul ">
                                                <li class="small text-muted">Destination</li>
                                                <li class="small">{{enquiry.destinations}}</li>
                                            </ul>
                                        </div>
                                        <div class="col-md-12 col-sm-12">

                                            <ul class="ml-4 mb-0 fa-ul ">
                                                <li class="small text-muted">Source</li>
                                                <li class="small">{{enquiry.source}}</li>
                                            </ul>
                                        </div>
                                        <div class="col-md-12 col-sm-12">

                                            <ul class="ml-4 mb-0 fa-ul ">
                                                <li class="small text-muted">Budget</li>
                                                <li class="small">  {{enquiry.budget}} </li>
                                            </ul>
                                        </div>
                                        <div class="col-md-12 col-sm-12">

                                            <ul class="ml-4 mb-0 fa-ul ">
                                                <li class="small text-muted">No. of Travelers</li>
                                                <li class="small">  Adults -  {{enquiry.adults}} </li>
                                                <li class="small">  Childs - {{enquiry.childs}} </li>
                                                <li class="small">  Infants - {{enquiry.infants}} </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12 col-sm-12">
                                            <ul class="ml-4 mb-0 fa-ul ">
                                                <li class="small text-muted">Specific Requirements</li>
                                                <li class="small">
                                                    <specific-requirements-display :text="enquiry.specific_requirements"></specific-requirements-display>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                    <div class="col-md-9">
                        <div class="col-12 card card-primary card-outline card-tabs">
                            <div class="card-header p-0 pt-1 border-bottom-0">
                                <ul class="nav nav-tabs" id="custom-tabs-three-tab" role="tablist">
                                    <li class="nav-item" v-for="quotation in quotations" >
                                        <a class="nav-link" :id="'quotation-'+quotation.id" data-toggle="pill" :href="'#quotation-tab-'+quotation.id" role="tab" :aria-controls="'quotation-'+quotation.id" aria-selected="false">
                                            QTN{{ quotation.id }}<br/> Rs.  {{quotation.quote_price}} <small>{{quotation.pricetypetext}}</small>

                                        </a>
                                    </li>

                                </ul>
                            </div>
                            <div class="card-body">
                                <div class="tab-content" id="custom-tabs-three-tabContent">
                                    <div class="tab-pane " v-for="quotation in quotations" :id="'quotation-tab-'+quotation.id" role="tabpanel" :aria-labelledby="'quotation-'+quotation.id">
                                        <div class="row mb-3">
                                            <div class="col-md-12">

                                                <a :href="'/enquiry/quote/create?enqid='+enquiry.encryptedid+'&bqid='+quotation.encryptedid"  >
                                                    <button  class="btn btn-primary btn-xs ml-2">Use Quote</button>

                                                </a>


                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-3">
                                                <p class="text-muted mb-0">Nights/Days</p>
                                                <p>{{quotation.nights}}Nights & {{quotation.nights+1}}Days</p>
                                            </div>
                                            <div class="col-3">
                                                <p class="text-muted mb-0">Quotation Price</p>
                                                <p>Rs. {{quotation.quote_price}} <small>{{quotation.pricetypetext}}</small></p>
                                            </div>
                                            <div class="col-3">
                                                <p class="text-muted mb-0">Destination</p>
                                                <p> <span v-for="destination in quotation.destinations">{{destination}}</span> </p>
                                            </div>
                                        </div>
                                        <div class="row" v-if="quotation.hotel_includes==1">
                                            <div class="col-12">
                                                <p class="text-muted mb-0">Hotel Details</p>
                                                <p v-for="hotel in quotation.hotels">
                                                    Nights {{ hotel.nights.join(",")}}, {{hotel.hotelname}}, {{hotel.city}}, {{hotel.category}}, {{hotel.roomtype}}, {{hotel.comments}}
                                                </p>
                                            </div>

                                        </div>
                                        <div class="row" v-if="quotation.flight_includes==1">
                                            <div class="col-12">
                                                <p class="text-muted mb-0">Flight Details</p>
                                                <img v-if="quotation.flightdetails!=null && quotation.flightdetails.includes('data:image')" :src="quotation.flightdetails">
                                                <p v-else>
                                                    {{quotation.flightdetails}}
                                                </p>
                                            </div>

                                        </div>
                                        <div class="row" >
                                            <div class="col-6">
                                                <p class="text-muted mb-0">Inclusions</p>
                                                <ul>
                                                    <li v-for="inclusion in quotation.inclusions">{{inclusion}}</li>
                                                </ul>
                                            </div>
                                            <div class="col-6">
                                                <p class="text-muted mb-0">Exclusions</p>
                                                <ul>
                                                    <li v-for="exclusion in quotation.exclusions">{{exclusion}}</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="row" v-for="daytn in quotation.itenaries">
                                            <div class="col-12">
                                                <p class="text-muted mb-0">Day {{daytn.day}} : {{daytn.title}}</p>

                                                <p>
                                                    {{daytn.description}}
                                                </p>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>



    </div>





</template>

<script>
import $ from 'jquery';
import moment from 'moment';
import SpecificRequirementsDisplay from './Enquiry/Components/SpecificRequirementsDisplay.vue';
export default {
    name: "BestMatchingQuotation",
    components: { SpecificRequirementsDisplay },
    props:['id'],
    data() {
        return {
            loading:false,
            enquiry:null,
            quotations:null,
    }
    },
    mounted() {

        this.getdetails();

    },
    methods: {


        getdetails() {

            let currentObj = this;
            axios.get('/enquirydetails?id='+this.id).then(function (response) {
                currentObj.enquiry=response.data.enquiry;
    })
                .catch(function (error) {
                });


            axios.get('/getbestmatchingquotes?id='+this.id).then(function (response) {
                currentObj.quotations=response.data;


            })
                .catch(function (error) {
                });
        }

    }
}
</script>

<style scoped>

</style>
